// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Tooltip/Placement.story.tsx with go/sail-next-tailor-docs-publisher 

import React, { useRef } from 'react';
import { Button, Tooltip, Info, view, css } from '@sail/ui';

const grid = template => css({
  display: css.value('grid'),
  gridTemplate: css.value(template)
});

const gridArea = name => css({
  gridArea: css.value(name)
});

const Example = view.div.extend(({
  placement,
  ...props
}, View) => {
  const ref = useRef(null);
  return <View uses={[props]}>
        <Button ref={ref} onPress={undefined}>
          <Info />
        </Button>
        <Tooltip delay={0} placement={placement} trigger={ref}>
          <view.dl css={{
        margin: 0
      }}>
            <view.dt css={{
          font: 'kicker'
        }}>placement:</view.dt>
            <view.dd css={{
          font: 'lead'
        }}>&quot;{placement}&quot;</view.dd>
          </view.dl>
        </Tooltip>
      </View>;
});
export const Placement = () => {
  return <view.div uses={[grid(`
          ".  tl t tr  ."
          "lt .  .  . rt"
          "l  .  .  .  r"
          "lb .  .  . rb"
          ".  bl b br  ."
        `)]} css={{
    gap: 'small'
  }}>
      <Example placement="top left" uses={[gridArea('tl')]} />
      <Example placement="top" uses={[gridArea('t')]} />
      <Example placement="top right" uses={[gridArea('tr')]} />

      <Example placement="right top" uses={[gridArea('rt')]} />
      <Example placement="right" uses={[gridArea('r')]} />
      <Example placement="right bottom" uses={[gridArea('rb')]} />

      <Example placement="bottom right" uses={[gridArea('br')]} />
      <Example placement="bottom" uses={[gridArea('b')]} />
      <Example placement="bottom left" uses={[gridArea('bl')]} />

      <Example placement="left bottom" uses={[gridArea('lb')]} />
      <Example placement="left" uses={[gridArea('l')]} />
      <Example placement="left top" uses={[gridArea('lt')]} />
    </view.div>;
};